import { useState } from 'react';

import { useAuth } from 'lib/auth';
import { SettingsEntryList } from 'features/settings/components/SettingsEntryList';
import { SettingsOverlay } from 'features/settings/components/SettingsOverlay';
import { useSetupSummary } from '../api/getSetupSummary';
import { LevelStructuresOverlay } from './LevelStructuresOverlay';
import { LotsOverlay } from './LotsOverlay';
import { RatesOverlay } from './RatesOverlay';
import { RolesOverlay } from './RolesOverlay';

const settingsTabName = 'settings';
const feesIdProps = {
  framework_agreements: 'frameworkAgreementId',
  dps: 'dpsId',
  directs: 'directId',
};

export const SettingsTab = ({ currentTab, resource, id, procurementName }) => {
  const { account } = useAuth();
  const isVisible = currentTab === settingsTabName && !!account?.super_admin;
  const [openOverlay, setOpenOverlay] = useState(null);

  const { data: summary, refetch } = useSetupSummary(resource, id, { enabled: isVisible });

  if (!isVisible) return null;

  const items = [
    { label: 'Lots', count: summary.lots, onClick: () => setOpenOverlay('lots') },
    {
      label: 'Level structures',
      count: summary.level_structures,
      onClick: () => setOpenOverlay('level_structures'),
    },
    { label: 'Roles', count: summary.roles, onClick: () => setOpenOverlay('roles') },
    { label: 'Rates', count: summary.rates, onClick: () => setOpenOverlay('rates') },
    { label: 'Fees', onClick: () => setOpenOverlay('fees') },
  ];

  const closeOverlay = () => {
    setOpenOverlay(null);
    refetch();
  };

  return (
    <SettingsEntryList items={items}>
      {openOverlay === 'lots' && (
        <LotsOverlay
          resource={resource}
          id={id}
          procurementName={procurementName}
          onClose={closeOverlay}
        />
      )}
      {openOverlay === 'level_structures' && (
        <LevelStructuresOverlay
          resource={resource}
          id={id}
          procurementName={procurementName}
          onClose={closeOverlay}
        />
      )}
      {openOverlay === 'roles' && (
        <RolesOverlay
          resource={resource}
          id={id}
          procurementName={procurementName}
          onClose={closeOverlay}
        />
      )}
      {openOverlay === 'rates' && (
        <RatesOverlay
          resource={resource}
          id={id}
          procurementName={procurementName}
          onClose={closeOverlay}
        />
      )}
      {openOverlay === 'fees' && (
        <SettingsOverlay
          name={procurementName}
          {...{ [feesIdProps[resource]]: id }}
          onClose={closeOverlay}
        />
      )}
    </SettingsEntryList>
  );
};
